export default __webpack_public_path__ + "static/media/loc-arte-7.f99def23.webp";